/**
 * Tooltip — 호버/포커스 시 추가 정보를 표시하는 순수 CSS 툴팁
 *
 * JavaScript 상태 없이 CSS :hover 및 :focus-within으로 동작한다.
 */

import { ReactNode } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Tooltip.module.css'

interface TooltipProps {
  /** 툴팁에 표시할 내용 */
  content: ReactNode
  /** 툴팁 표시 위치. 기본값 top */
  position?: 'top' | 'bottom' | 'left' | 'right'
  /** 툴팁을 트리거할 자식 요소 */
  children: ReactNode
  className?: string
}

export function Tooltip({
  content,
  position = 'top',
  children,
  className,
}: TooltipProps) {
  return (
    <span className={cn(styles.root, className)}>
      {children}
      <span className={cn(styles.bubble, styles[position])}>{content}</span>
    </span>
  )
}
